import {  
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import MyRoutes from "./utils/MyRoutes";
import { AuthProvider } from "./context/AuthProvider";

const routes = createBrowserRouter(MyRoutes);

function App() {
  return (
    <AuthProvider>
      <RouterProvider router={routes} />
    </AuthProvider>
   
  );
}
 
export default App;
